import { type AutocompleteRenderGroupParams } from '@mui/joy';

import { type AutocompleteOption } from '../hooks/autocomplete';

import VirtualListBoxAdapter, {
  type VirtualRenderers,
} from '../components/2.0/adapters/VirtualListBoxAdapter';

const simpleVirtualAutocompleteProps = {
  renderGroup: (params: AutocompleteRenderGroupParams) => params as unknown as React.ReactNode,
  renderOption: <T>(props: Omit<React.HTMLAttributes<HTMLLIElement>, 'color'>, option: T) =>
    [props, option] as React.ReactNode,
  slots: { listbox: VirtualListBoxAdapter },
};

const createVirtualAutocompleteAdapter = <T extends AutocompleteOption>(
  renderers?: VirtualRenderers<T>,
) => ({
  ...simpleVirtualAutocompleteProps,
  slotProps: {
    listbox: renderers,
  },
});

const virtualAutocompleteAdapter = {
  baseProps: simpleVirtualAutocompleteProps,
  create: createVirtualAutocompleteAdapter,
};

export default virtualAutocompleteAdapter;
